define.alias("shared/components/shared/post/secondary/activity/divider", "calendar/components/shared/post/secondary/activity/divider");